import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { HttpClient } from '@angular/common/http';
import urljoin from 'url-join';
import { AssignedReview, TrainerReview } from '../models/trainer';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PlayerTraining } from '../models/player-training';

@Injectable({
  providedIn: 'root',
})
export class TrainerService extends APIService {
  readonly onUpdate$ = new Subject<void>();

  constructor(private http: HttpClient) {
    super();
  }

  public async getTrainerReviews() {
    const url = urljoin(this.BASE_URL, `skill-trainings/trainers/reviews/`);
    return this.http.get<AssignedReview[]>(url).toPromise();
  }

  public async toggleWerderBremenTag(playerId: number) {
    const url = urljoin(
      this.BASE_URL,
      `users/toggle/werder-bremen/${playerId}/`
    );
    return this.http.post<{ werder_tag: boolean }>(url, {}).toPromise();
  }

  public async toggleSelectionTag(playerId: number) {
    const url = urljoin(
      this.BASE_URL,
      `users/toggle/werder-bremen/toggle_selection/${playerId}/`
    );
    return this.http.post<{ selection_tag: boolean }>(url, {}).toPromise();
  }

  public async togglePreselectionTag(playerId: number) {
    const url = urljoin(
      this.BASE_URL,
      `users/toggle/werder-bremen/toggle_preselection/${playerId}/`
    );
    return this.http.post<{ preselection_tag: boolean }>(url, {}).toPromise();
  }

  public async getWerderBremenTests(playerId: number) {
    const url = urljoin(
      this.BASE_URL,
      `skill-trainings/players/${playerId}/werder-bremen-tests/`
    );
    return this.http.get<PlayerTraining[]>(url).toPromise();
  }

  public async updateTrainerReview(reviewId: number, body: TrainerReview) {
    const url = urljoin(
      this.BASE_URL,
      `skill-trainings/trainers/reviews/${reviewId}/`
    );
    return this.http
      .patch(url, body)
      .pipe(
        tap(() => {
          this.onUpdate$.next();
        })
      )
      .toPromise();
  }
}
